import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, styled } from '@mui/material';

interface SBSMonitoringFilterProps {
  filterType: string;
  setFilterType: (value: string) => void;
}

const SBSMonitoringFilter: React.FC<SBSMonitoringFilterProps> = ({ filterType, setFilterType }) => {
  enum SBSMonitoringFilterType {
    default = 'Show all',
    eatenOnly = 'Show only bait consumed',
    visitedOnly = 'Show only visited without consuming bait',
    replaceOrAdd = 'Show replace or add bait',
    replaceAddOrEaten = 'Show any activity',
  }

  const CustomSelect = styled(Select)({
    '&.MuiInputBase-root': {
      backgroundColor: 'transparent',
      boxShadow: 'none',
      borderColor: 'red',
    },
    '& .MuiSelect-select': {
      padding: '10px 12px',
      paddingRight: '24px',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: '1px solid #E0E0E0',
    },
  });

  const handleChange = (event: SelectChangeEvent<unknown>) => {
    setFilterType(event.target.value as SBSMonitoringFilterType);
  };

  const filters = Object.keys(SBSMonitoringFilterType);
  return (
    <div className="buttons mt-2 mt-lg-0">
      <FormControl sx={{ minWidth: 120 }}>
        <InputLabel id="demo-simple-select-standard-label" sx={{ fontFamily: 'Poppins, sans-serif' }}>
          Current filter applied
        </InputLabel>
        <CustomSelect
          value={filterType}
          onChange={handleChange}
          id="demo-simple-select-filled"
          label="Current Filter Applied"
          sx={{ width: 250, fontFamily: 'Poppins, sans-serif' }}
        >
          {filters.map(key => (
            <MenuItem key={key} value={key} sx={{ fontFamily: 'Poppins, sans-serif' }}>
              {SBSMonitoringFilterType[key as keyof typeof SBSMonitoringFilterType]}
            </MenuItem>
          ))}
        </CustomSelect>
      </FormControl>
    </div>
  );
};

export default SBSMonitoringFilter;
